<script>
    import {onMount, createEventDispatcher} from 'svelte';
    import {validateAtInput} from './Form/utils.js';
    import {sgettext} from '../i18n.js';

    export let value = '';
    export let id = '';
    export let key = '';
    export let label = '';
    export let placeholder = '';
    export let required = false;
    export let isValid = true;
    export let errors = '';
    export let schema = null;
    export let multiline = false;
    export let floatClass = '';
    export let additionalClass = '';
    export let hidden = false;
    export let help = '';
    export let rows = 2;
    export let object = {};
    export let maxlength = '';
    export let readonly = false;
    export let ignoreFieldLevelValidation = false;
    export let focus = false;
    export let handleKeyPress = e => {};

    let touched = false;

    const dispatch = createEventDispatcher();

    if (!key) {
        key = id;
    }

    async function handleOnBlur(event) {
        if (!ignoreFieldLevelValidation) {
            try {
                if (schema && schema.fields.hasOwnProperty(key)) {
                    await validateAtInput(schema, key, object);
                    isValid = true;
                    errors = '';
                }
            } catch (err) {
                isValid = false;
                errors = err.message;
            }
        }
    }

    onMount(() => {
        // Wait for mount and focus this element on mount if focus=true
        if (focus) {
            document.getElementById(id).focus()
        }         
    })
</script>

<style>
    .errors {
        color: #dc3545;
        font-size: 13px;
    }

    .text-input {
        height: 44px;
    }

    .invalid {
        border-color: #dc3545;
    }
</style>

<!--
If dragging is enabled on a parent element, the following combination blocks dragging if mousedown occurs on the text input.
  draggable={true}
  on:dragstart={(ev) => ev.preventDefault()}
-->

{#if label}
    <label for={id} title={required ? sgettext('$$FIELD_REQUIRED$$') : ''}>
        {label}
    </label>
{/if}
{#if !multiline}
    <input
        draggable={true}
        on:dragstart={(ev) => ev.preventDefault()}
        type="text"
        autocomplete="off"
        {id}
        class:invalid={!isValid}
        {placeholder}
        class="form-control text-input {floatClass}
        {additionalClass}"
        class:hidden
        bind:value
        on:change
        on:input
        on:keyup
        on:focus={(event) => {touched = true; dispatch('focus', event.detail);}}
        on:blur={handleOnBlur}
        on:keypress={handleKeyPress}
        readonly={readonly}
    />
{:else}
    <textarea
        draggable={true}
        maxlength={maxlength}
        on:dragstart={(ev) => ev.preventDefault()}
        {id}
        {placeholder}
        {rows}
        class:invalid={!isValid}
        class="form-control {floatClass}
        {additionalClass}"
        class:hidden
        bind:value
        on:keyup
        on:change
        on:input
        on:focus={() => (touched = true)}
        on:blur={handleOnBlur}
        on:keypress={handleKeyPress}
        readonly={readonly}
    />
{/if}
{#if help}
    <small class="form-text text-muted">{help}</small>
{/if}

{#if !isValid}
    <div class="errors" data-testid="textinput-errors">{errors}</div>
{/if}
